<div class="bg-white h-100">
  <era-master-detail flexGrowLeft="1"
                     flexGrowRight="2">
    <era-master>
      <era-panel>

        @if ((profiles()) === null || (profiles()) === undefined) {
          <ml-sk-spinner-3></ml-sk-spinner-3>
        } @else if (profiles(); as profiles) {
          @if (profiles?.length > 0) {
            <div class="list-group list-group-flush border-bottom">
              @for (p of profiles; track p) {
                <a class="list-group-item list-group-item-action"
                   [routerLink]="[p.payloadUUID]"
                   routerLinkActive="active">
                  {{ p.payloadDisplayName }}
                </a>
              }
            </div>
          } @else {
            <div class="d-flex h-100 w-100 align-items-center justify-content-center">
              <div class="text-center text-muted p-4">
                <p>No profiles have been installed on this device yet.</p>
                <small>Please refresh to retrieve the latest profiles from the device.</small>
              </div>
            </div>
          }
        }

        <era-panel-footer>
          <div class="btn-toolbar p-1 bg-gray-100 border-top">
            <button type="button"
                    class="btn btn-outline-primary border-0"
                    (click)="showInstallProfileModal()">
              <fa-icon icon="plus"></fa-icon>
            </button>
            <ml-mdm-command-spinner [commandProgress]="refreshProfilesProgress"
                                    [small]="true"
                                    [direction]="'right'"
                                    [reverse]="true"
                                    class="flex-grow-1 text-end">
              @if (udid | async; as udid) {
                <button type="button"
                        (click)="refresh(udid)"
                        class="btn btn-outline-primary border-0"
                        data-testid="refresh-profiles-button">
                  <fa-icon icon="sync"></fa-icon>
                </button>
              }
            </ml-mdm-command-spinner>
          </div>
        </era-panel-footer>
      </era-panel>
    </era-master>
  </era-master-detail>
</div>